import { render, staticRenderFns } from "./DistributorTotal.vue?vue&type=template&id=e0cabc08&scoped=true&"
import script from "./DistributorTotal.vue?vue&type=script&lang=js&"
export * from "./DistributorTotal.vue?vue&type=script&lang=js&"
import style0 from "./DistributorTotal.vue?vue&type=style&index=0&id=e0cabc08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cabc08",
  null
  
)

export default component.exports